export enum EventReceiverCatalog {
  PRICEBREAKDOWN_TOTAL_PRICE_QUERY_DISPATCHED = "PRICEBREAKDOWN_TOTAL_PRICE_QUERY_DISPATCHED",
  MEMBERSHIP_PRODUCT_EVALUATION_CODE_DISPATCHED = "MEMBERSHIP_PRODUCT_EVALUATION_CODE_DISPATCHED",
  MEMBERSHIP_PRODUCT_DATA_DISPATCHED = "MEMBERSHIP_PRODUCT_DATA_DISPATCHED",
}

export enum EventEmitterCatalog {
  // System actions
  TRACKING = "TRACKING",
  MEMBERSHIP_PRODUCT_EVALUATION_CODE_DISPATCHED = "MEMBERSHIP_PRODUCT_EVALUATION_CODE_DISPATCHED",
  MEMBERSHIP_PRODUCT_DATA_DISPATCHED = "MEMBERSHIP_PRODUCT_DATA_DISPATCHED",
}

export type EventCatalog = EventEmitterCatalog | EventReceiverCatalog;
